import { Box, useTheme } from "@mui/material";

/**
 * The "Insight Analytics" wordmark that heads the onboarding's text-led
 * screens (hook, commitment, mission, honesty). Height and the gap beneath it
 * live here rather than at each call site so the mark renders identically on
 * every screen that carries it — it must not resize or shift as the user taps
 * through the flow.
 */

const WORDMARK_HEIGHT = 32;

export const BrandWordmark = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
      <Box
        component="img"
        src={isDark ? "/insightLongLogoWhite.svg" : "/insightLongLogoPrimary.svg"}
        alt="Insight Analytics"
        sx={{ height: WORDMARK_HEIGHT, width: "auto" }}
      />
    </Box>
  );
};
